module.exports = __webpack_public_path__ + "img/bg_12.75bb1596.png";